import { createSlice } from "@reduxjs/toolkit";

// Header breadcrumb trail. Pages set it on mount:
//   dispatch(setBreadcrumb([
//     { title: "VIM List", link: "/vim-list" },
//     { title: deviceId, current: true },
//   ]))
const initialState = {
    trail: [],
}

const breadcrumbSlice = createSlice({
    name: "breadcrumb",
    initialState,
    reducers: {
        setBreadcrumb: (state, action) => {
            state.trail = action.payload ?? [];
        },
        clearBreadcrumb: (state) => {
            state.trail = [];
        },
    }})

export const { setBreadcrumb, clearBreadcrumb } = breadcrumbSlice.actions;

export const selectBreadcrumb = (state) => state.breadcrumb.trail;

export default breadcrumbSlice.reducer;